<template>
  <section>
    <v-dialog
      v-model="modalAction"
      max-width="600px"
      scrollable
      @keydown="executeCloseModalFilterDocumentNames"
      @click:outside="executeCloseModalFilterDocumentNames"
    >
      <v-card>
        <div class="p-4 pb-0">
          <h5>Filtros de Nombres de Documentos</h5>
        </div>
        <hr />
        <v-card-text>
          <v-row class="px-4">
            <v-col cols="12" lg="12" md="12" sm="12" class="mb-2">
              <v-text-field
                label="Búsqueda"
                v-model="filters.filter"
                clearable
                class="mt-3"
                placeholder="Búsqueda"
                append-icon="mdi-magnify"
              ></v-text-field>
              <div class="d-flex align-items-center justify-content-start">
                <v-checkbox
                  @change="validateCheckFilter('folder')"
                  v-model="filters.only_folder"
                  class="mt-0 mr-3"
                >
                  <template v-slot:label>
                    <h6 class="mt-2 mb-0">Carpeta Contenedora</h6>
                  </template>
                </v-checkbox>
                <v-checkbox
                  @change="validateCheckFilter('name')"
                  v-model="filters.only_name"
                  class="mt-0 mx-5"
                >
                  <template v-slot:label>
                    <h6 class="mt-2 mb-0">Nombre de Documento</h6>
                  </template>
                </v-checkbox>
              </div>
            </v-col>
            <v-col
              cols="12"
              lg="12"
              md="12"
              sm="12"
              class="mb-2"
              v-if="businessUnits.length > 1 && !isProject && !isPresale"
            >
              <v-autocomplete
                class="mt-3"
                @change="
                  getAssignedAreas({
                    business_unit_filter: filters.business_unit,
                  });
                  filters.assigned_area = null;
                "
                placeholder="Filtrar por Unidad de Negocio"
                v-model="filters.business_unit"
                :items="activeBusinessUnits"
                item-text="name"
                item-value="code"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12" class="mb-2">
              <v-autocomplete
                class="mt-3"
                placeholder="Filtrar por Área Responsable"
                v-model="filters.assigned_area"
                :items="assignedAreas"
                item-text="name"
                item-value="id"
                clearable
                no-data-text="Sin Áreas Responsables"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12" class="mb-2">
              <v-autocomplete
                v-model="filters.items"
                class="mt-3"
                :items="[5, 10, 15, 20, 25, 100]"
                label="Items por Página"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12" class="mb-2">
              <v-checkbox v-model="filters.only_required" class="mt-5">
                <template v-slot:label>
                  <h6 class="mt-2 mx-1 mb-0">Solo Documentos Obligatorios</h6>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="emitClearAllFilters">
            <small> Limpiar Filtros </small>
          </v-btn>
          <v-btn
            color="red darken-1"
            outlined
            @click="executeCloseModalFilterDocumentNames"
          >
            <small> Cerrar </small>
          </v-btn>
          <v-btn color="primary" @click="searchFilters">
            <small> Buscar </small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { preventCloseIfNotKeyEventEsc } from "@/helpers/common";
import { ACTIVE_BUSINESS_UNITS } from "@/constants/common";
import { mapActions } from "vuex";

export default {
  props: {
    modalAction: {
      type: Boolean,
      default: false,
    },
    closeModalFilterDocumentNames: {
      type: Function,
      default: () => {},
    },
    isProject: {
      type: Boolean,
      default: false,
    },
    isPresale: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: {
        filter: null,
        business_unit: null,
        assigned_area: null,
        only_required: false,
        only_folder: true,
        only_name: true,
        items: 10,
      },
    };
  },
  methods: {
    ...mapActions({
      getAssignedAreas: "document/getAssignedAreas",
    }),
    executeCloseModalFilterDocumentNames($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.closeModalFilterDocumentNames($event);
      }
    },
    emitClearAllFilters() {
      this.filters.filter = null;
      this.filters.business_unit = null;
      this.filters.assigned_area = null;
      this.filters.items = 10;
      this.filters.only_required = false;
      this.filters.only_folder = true;
      this.filters.only_name = true;
      this.$emit("clearAllFilters");
    },
    searchFilters() {
      this.$emit("searchFilters", {
        filter: this.filters.filter,
        business_unit: this.filters.business_unit,
        assigned_area: this.filters.assigned_area,
        only_required: this.filters.only_required,
        only_folder: this.filters.only_folder,
        only_name: this.filters.only_name,
        items: this.filters.items,
      });
      this.closeModalFilterDocumentNames(true);
    },
    validateCheckFilter(check_selected) {
      if (!this.filters.only_folder && !this.filters.only_name) {
        if (check_selected == "name") {
          this.filters.only_folder = true;
        } else {
          this.filters.only_name = true;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      documentsTypes: "document/documentsTypes",
      businessUnits: "document/businessUnits",
      assignedAreas: "document/assignedAreas",
    }),
    activeBusinessUnits() {
      return this.businessUnits.filter((item) =>
        ACTIVE_BUSINESS_UNITS.includes(item.name)
      );
    },
  },
};
</script>

<style></style>
